import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-wavy-circle",
  "use": "foquz-icon-wavy-circle-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-wavy-circle\"><circle cx=\"7\" cy=\"7\" r=\"6\" fill=\"#73808D\" /><path d=\"M4.051 7.497c.34-.37 1.596-1.104 2.984-.307 1.39.798 2.646.062 2.985-.307\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" /><rect x=\".5\" y=\".5\" width=\"13\" height=\"13\" rx=\"6.5\" stroke=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol